import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App' 
import { Provider } from 'react-redux'
import store from './store'
import { SecurityProvider } from './security/securityStore';
import { ThemeProvider } from './ThemeContext'

createRoot(document.getElementById('root')).render(
  <ThemeProvider>
  <SecurityProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </SecurityProvider>
</ThemeProvider>
,
) 
